import React, { createContext, useContext, useReducer, ReactNode } from "react";
import { SupportedLocales } from "./IntlContext";
import { IThirdPartyService, IProduct } from "../request";

type State = {
  services: IThirdPartyService[];
  products: IProduct[];
  lang: SupportedLocales;
  token: string;
};

type Action =
  | { type: "SAVE_PRODUCTS"; payload: IProduct[] }
  | { type: "SAVE_SERVICES"; payload: IThirdPartyService[] }
  | { type: "SET_LANG"; payload: SupportedLocales }
  | { type: "SET_TOKEN"; payload: string };

const initialState: State = {
  products: [],
  services: [],
  lang: SupportedLocales.English,
  token: "",
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "SAVE_PRODUCTS":
      return { ...state, products: action.payload };
    case "SAVE_SERVICES":
      return { ...state, services: action.payload };
    case "SET_LANG":
      return { ...state, lang: action.payload };
    case "SET_TOKEN":
      return { ...state, token: action.payload };
    default:
      return state;
  }
};
const StoreContext = createContext<{
  state: State;
  dispatch: React.Dispatch<Action>;
}>({ state: initialState, dispatch: () => {} });

export const useStoreContext = () => useContext(StoreContext);

export const StoreProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StoreContext.Provider value={{ state, dispatch }}>
      {children}
    </StoreContext.Provider>
  );
};
